<template>
  <skeletor v-if="imageLoading" :width="widthSkeletor" :height="heightSkeletor" :class="classSkeletor"/>
  <figure ref="figure">
    <img
      v-show="image && !imageLoading"
      ref="photo"
      :class="imgClass"
      :alt="image?.alt"
      :title="altImg || image?.title"
      :width="imgWidth"
      :height="preloadHeight"
    />
  </figure>
</template>

<script setup>
import { nextTick, ref, watch, onMounted } from 'vue'
import { useUtils } from '@/composables/useUtils'

const props = defineProps({
  widthSkeletor: {
    type: [Number, String],
    default: '100%'
  },
  heightSkeletor: {
    type: [Number, String],
    default: '100%'
  },
  image: {
    type: Object,
    default: () => ({})
  },
  imgClass: {
    type: String,
    default: ''
  },
  imgWidth: {
    type: Number
  },
  imgHeight: {
    type: Number
  },
  classSkeletor: {
    type: String,
    default: ""
  },
  altImg: {
    type: String,
    default: ''
  }
})

const photo = ref(null)
const imageLoading = ref(true)

const { parseImageUrl } = useUtils()

const figure = ref(null)
const preloadHeight = ref(props.imgHeight)

const setHeight = () => {
  if (figure.value === undefined) {
    return
  }
  const clientWidth = figure.value?.clientWidth ?? null
  const elementWidth = clientWidth <= props.imgWidth ? clientWidth : props.imgWidth
  if (elementWidth) {
    preloadHeight.value = Math.round((elementWidth / props.imgWidth) * props.imgHeight)
  }
}

watch(
  () => [props.image, photo.value],
  () => {
    nextTick(() => {
      if (props.image) {
        const downloadImage = new Image()
        downloadImage.src = parseImageUrl(props.image?.url, props.imgWidth, props.imgHeight)
        if (photo.value) {
          photo.value.src = downloadImage.src
        }
        downloadImage.onload = () => {
          nextTick(() => {
            imageLoading.value = false
          })
        }
      }
    })
  },
  { immediate: true, deep: true }
)

onMounted(() => {
  nextTick(() => {
    setHeight()
  })
})
</script>

<style scoped lang="scss">
figure {
  display: block;

  img {
    width: 100%;
    display: block;
  }
}
</style>
